import { RestRequestType } from './../shared/enums/rest-request-type.enum';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { downloadFile } from 'file-saver';
import { environment } from 'environments/environment';
import { RestRequestResponse } from "../shared/interfaces/rest-request-response";

export interface IGQL { query: string; params?: { [param: string]: any } }

@Injectable({
  providedIn: 'root'
})

export class RestAPIService {
  currentViewRoute: any;
  readonly SPARKPLUG_ENDPOINT = ['rebirth'];
  readonly DS_ENDPOINT = ['live-data'];
  readonly TIMESERIES_ENDPOINT = ['timeseries'];
  private readonly payloadData = {
    specVersion: '1.0.0',
    source: 'intellija-ui',
    id: 'C234-1234-1234',
    dataContentType: 'application/json'
  };


  constructor( private http: HttpClient ) { }

  get<T = any>(endpoint: string, options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }): Observable<T> {
    return this.http.get<T>(this.getURL(endpoint), options || {}).pipe(first());
  }

  get2Test<T = any>(endpoint: string, options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }): Observable<T> {
    console.log('options: ', options);
    console.log('endpoint: ', endpoint);
    return this.http.get<T>(environment.REST_BASE_URL + `gqls/${endpoint}/query`, options || {}).pipe(first());
  }

  /**
   * get GQL data
   * @param payload payload
   */
  getGQLData<R = any>(queryInfo?: IGQL, options?: { headers?: HttpHeaders } | { [header: string]: string | string[] } ) {
    const payload = this.buildPayload(queryInfo.params, RestRequestType.FETCH_GQL) || null;
    payload.data = payload.data || {};
    return this.http.post<RestRequestResponse<R>>(environment.REST_BASE_URL + `gqls/${queryInfo.query}/query`, payload || {}, options || {});
  }

  post<R = any>(endpoint, type: RestRequestType, payload?: any, options?: { headers?: HttpHeaders } | { [header: string]: string | string[] } ) {
    payload = payload ? this.buildPayload(payload, type) : null;
    return this.http.post<RestRequestResponse<R>>(this.getURL(endpoint), payload || {}, options || {});
  }

  put<R = any>(endpoint, type: RestRequestType, payload?: any, options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }) {
    payload = this.buildPayload(payload, type);
    return this.http.put<RestRequestResponse<R>>(this.getURL(endpoint), payload || {}, options || {});
  }

  patch<R = any>(endpoint, type: RestRequestType, payload?: any, options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }) {
    payload = this.buildPayload(payload, type);
    return this.http.patch<RestRequestResponse<R>>(this.getURL(endpoint), payload || {}, options || {});
  }

  delete<R = any>(endpoint, options?: { headers?: HttpHeaders } | { [header: string]: string | string[] }) {
    console.log('delete: ', options);
      return this.http.delete<RestRequestResponse<R>>(this.getURL(endpoint), options || {});
  }

  downloadFileStart(url) {
    this.http.get(url, { responseType: 'arraybuffer' }).subscribe(response => downloadFile(response));
  }

  getURL(endpoint): string {
    if(this.SPARKPLUG_ENDPOINT.includes(endpoint)) {
      return `${environment.BASE_URL}sparkplug/api/v1/${endpoint}`;
    }else if (this.DS_ENDPOINT.includes(endpoint)){
      return `${environment.BASE_URL}ds/api/v1/${endpoint}`;
    }
    else if (this.TIMESERIES_ENDPOINT.includes(endpoint)){
      return `${environment.BASE_URL}timeseries/api/v1/${endpoint}?interpolated=true&format=json`;
    }

    return environment.REST_BASE_URL + endpoint;
  }

  buildPayload(data: any, type) {
    return {
      ...this.payloadData,
      time: new Date().toISOString(),
      type,
      data
    };
  }

}
